import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, HostBinding } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { Router, RouterLink } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FeaturedSpaceListPage } from './featured.space.list.page';
import { NearbyLocationListPage } from './nearby.location.list';
import { RandomLocationListPage } from './random.location.list';
import { SessionService } from './session.service';
import { UpcomingBookingListPage } from './upcoming.booking.list.page';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    FeaturedSpaceListPage,
    MatInputModule,
    RouterLink,
    FontAwesomeModule,
    UpcomingBookingListPage,
    CommonModule,
    NearbyLocationListPage,
    RandomLocationListPage,
  ],
  templateUrl: './home.component.html',
})
export class HomeComponent {
  @HostBinding('class') css = 'max-scroll';
  search = '';
  _common = _common;

  constructor(
    private http: HttpClient,
    private router: Router,
    public session: SessionService
  ) {}
  ngOnInit() {}
  goWizard() {
    this.router.navigate([this.session.path('/space-search')], {
      queryParams: {},
    });
  }
  goSearch() {
    if (!this.search.length) return;
    this.router.navigate([this.session.path('/space')], {
      queryParams: {
        search: this.search,
      },
    });
  }
}
